<template>
	<reportFormWrap
		ref="reportFormWrap"
		:reportid="reportid"
		:orderMenu="orderMenu"
		:settingCols="settingCols"
		:reportName="reportName"
		:exportUrl="exportUrl"
		:getFiltersParams="getFiltersParams"
		:getCustomThroughParams="getCustomThroughParams"
		@clearSearchClick='clearSearchClick'
		:sunTable="sunTable"
		:reportFormUrl="reportFormUrl">
		<FiltersBox slot="filters" ref="filters" @inputEnter='inputEnter'></FiltersBox>
		<IconTip slot="icontip"></IconTip>
	</reportFormWrap>
</template>

<script>
import { cols } from '@/js/reportform/couponDetail.js'
import { orderMenu } from '@/js/reportform/reportformCommon.js'
import reportFormWrap from '@/components/reportform/common/ReportFormWrapBigNew.vue'
import FiltersBox from '@/components/reportform/couponDetail/FiltersBox.vue'
import IconTip from '@/components/reportform/couponDetail/IconTip.vue'
export default {
	name: 'couponDetail',
	components: {
		reportFormWrap,
		FiltersBox,
		IconTip
	},
	data () {
		return {
			reportid: 'REPORT_YHQMX_000001',
			settingCols: cols,
			reportFormUrl: `${this.$fxBaseApi.urlReport}/report/getDiscountReport`,
			exportUrl: `${this.$fxBaseApi.newExportUrl}/discountReportImport`,
			orderMenu: orderMenu,
			reportName: 'couponDetail',
			sunTable: [{
				name: '已发出',
				key: 'countcoupon'
			}, {
				name: '已使用',
				key: 'usedcoupon'
			}, {
				name: '已使用金额',
				key: 'usedmoney'
			}, {
				name: '累计单量',
				key: 'orderidcount'
			}, {
				name: '累计订单金额',
				key: 'ordermoney'
			}]
		}
	},
	mounted () {
		this.$refs.reportFormWrap.initReportForm()
	},
	methods: {
		clearSearchClick () {
			this.$refs.filters.clearSearch()
		},
		inputEnter () {
			return this.$refs.reportFormWrap.searchHandler()
		},
		getFiltersParams () {
			return this.$refs.filters.getFiltersParams()
		},
		getCustomThroughParams () {
			return this.$refs.filters.getFiltersDate()
		}
	}
}
</script>
